import { ButtonProps } from '@mui/material';

import { ConfirmDialog, Typography } from '@occc/ui-design-system';

export type ActionConfirmDialogProps = {
  onClose: () => void;
  onConfirm: () => void;
  message: string;
  confirmButtonColor?: ButtonProps['color'];
  confirmButtonDisabled?: boolean;
};

export const ActionConfirmDialog = ({
  onClose,
  onConfirm,
  message,
  confirmButtonColor = 'error',
  confirmButtonDisabled = false,
}: ActionConfirmDialogProps) => {
  return (
    <ConfirmDialog
      dialogTitle='Are you sure?'
      onClose={onClose}
      open
      maxWidth='sm'
      confirmButtonText='Confirm'
      confirmButtonProps={{
        onClick: onConfirm,
        disabled: confirmButtonDisabled,
        color: confirmButtonColor,
      }}
    >
      <Typography>{message}</Typography>
    </ConfirmDialog>
  );
};
